'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _ChannelList = require('@/components/ChannelList.vue');

var _ChannelList2 = _interopRequireDefault(_ChannelList);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _TextFormatting = require('@/helpers/TextFormatting');

var TextFormatting = _interopRequireWildcard(_TextFormatting);

var _MessageFormatter = require('@/libs/MessageFormatter');

var _MessageFormatter2 = _interopRequireDefault(_MessageFormatter);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    mixins: [_ChannelList2.default],
    data: function data() {
        return {
            page_size: 10
        };
    },

    computed: {
        isJoined: function isJoined() {},
        filteredList: function filteredList() {
            var _this = this;

            var list = [];

            if (this.search.length <= 2) {
                list = this.list;
            } else {
                list = this.list.filter(function (channel) {
                    var found = false;
                    if (channel.channel.toLowerCase().indexOf(_this.search.toLowerCase()) > -1) {
                        found = true;
                    }
                    if (channel.topic.toLowerCase().indexOf(_this.search.toLowerCase()) > -1) {
                        found = true;
                    }
                    return found;
                });
            }

            return _lodash2.default.sortBy(list, 'num_users').reverse();
        }
    }
};


//////////////////
// WEBPACK FOOTER
// ./build/exports-loader.js!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/customized-core/ChannelList.vue
// module id = brhi
// module chunks = 1